var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurnetworkLinemob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 4,
    viewBox: "0 0 231 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.206526 2L2 3.79347L3.79347 2L2 0.206526L0.206526 2ZM230.793 1.99998L229 0.206506L227.207 1.99998L229 3.79345L230.793 1.99998ZM2 2.31064L229 2.31062L229 1.68934L2 1.68936L2 2.31064Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurnetworkLinemob);
export default __webpack_public_path__ + "static/media/ournetworkLinemob.0b9bc0b58b2d724d9047e06f44140ab7.svg";
export { ForwardRef as ReactComponent };